export class PrefectureDropdownController {
  constructor(controller) {
    this.controller = controller;
  }

  // ========================================
  // 都道府県ドロップダウン
  // ========================================

  togglePrefectureDropdown(event) {
    event.stopPropagation();
    this.closeCityDropdown();

    const dropdown = this.controller.prefectureDropdownTarget;

    if (dropdown) {
      if (dropdown.style.display === 'none' || dropdown.style.display === '') {
        dropdown.style.display = 'block';
      } else {
        dropdown.style.display = 'none';
      }
    }
  }

  closePrefectureDropdown() {
    if (this.controller.hasPrefectureDropdownTarget) {
      this.controller.prefectureDropdownTarget.style.display = 'none';
    }
  }

  // ========================================
  // 都道府県選択
  // ========================================

  async selectPrefecture(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const prefectureId = button.dataset.prefectureId;
    const prefectureName = button.dataset.prefectureName;

    // 前回選択された都道府県ボタンのselectedクラスを削除
    const allButtons = this.controller.prefectureDropdownTarget.querySelectorAll('.area-search__dropdown-button');
    allButtons.forEach(btn => btn.classList.remove('selected'));

    // 新しく選択されたボタンにselectedクラスを追加
    button.classList.add('selected');

    // 選択状態を更新
    this.controller.selectedPrefectureId = prefectureId;
    this.controller.selectedPrefecture = prefectureName;

    // テキストを更新
    this.controller.prefectureTextTarget.textContent = prefectureName;
    this.controller.prefectureInputTarget.classList.add('area-search__select--selected');

    // ドロップダウンを閉じる
    this.closePrefectureDropdown();

    // 市区町村をリセット
    this.controller.selectedCity = null;
    this.controller.selectedCityName = null;

    this.controller.cityTextTarget.textContent = '選択してください';
    this.controller.cityInputTarget.classList.remove('area-search__select--selected');

    // 市区町村リストを即座にクリアしてローディング表示
    this.controller.cityButtonsContainerTarget.textContent = '';
    const loadingDiv = document.createElement('div');
    loadingDiv.className = 'area-search__dropdown-loading';
    loadingDiv.textContent = '読み込み中...';
    this.controller.cityButtonsContainerTarget.appendChild(loadingDiv);

    // 市区町村を取得（CityDropdownControllerに委譲）
    await this.controller.cityDropdownController.loadCities(prefectureName);
  }

  closeCityDropdown() {
    this.controller.cityDropdownController.closeCityDropdown();
  }
}
